/** @jsx jsx */
import { jsx } from 'theme-ui'
import Modal from 'react-modal'
import { useState } from 'react'
import { JUDGES_CONFIG } from './judgesConfig'
import Divider from '../divider'
import { Container } from '../container'
import RoundedImage from '../roundedImage'

const customModalStyles = {
  overlay: {
    backgroundColor: 'rgba(20, 20, 20, 0.1)',
    backdropFilter: 'blur(0.02em)',
    zIndex: 9999999
  },
  content: {
    border: 'none',
    backgroundColor: 'transparent',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
}

const CloseModalIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0001 17.4142L23.293 24.7071L24.7072 23.2929L17.4143 16L24.7072 8.70706L23.293 7.29285L16.0001 14.5858L8.70718 7.29285L7.29297 8.70706L14.5859 16L7.29302 23.2929L8.70723 24.7071L16.0001 17.4142Z"
      fill="#F5F5F5"
    />
  </svg>
)

const ModalPopUp = ({
  name,
  title,
  imgUrl,
  bio,
  socialMediaTag,
  socialMediaHref,
  onClick
}) => (
  <div
    sx={{
      background: '#242424',
      width: '100%',
      p: ['16px', '72px 32px'],
      borderRadius: 8,
      height: '100%',
      color: 'white',
      position: 'relative',
      maxWidth: ['100%', '676px']
    }}
  >
    <div
      sx={{
        position: 'absolute',
        top: [25, 25, 30],
        right: [20, 20, 30],
        fontSize: 24,
        cursor: 'pointer'
      }}
      onClick={onClick}
    >
      <CloseModalIcon />
    </div>
    <h3 sx={{ color: '#F6F6F6', fontSize: 32 }}>{name}</h3>
    <RoundedImage imgUrl={imgUrl} />
    <p sx={{ fontWeight: 400, my: 16, color: '#ADADAD' }}>{title}</p>

    <Divider />
    <div>
      <h5 sx={{ fontSize: 24, mb: 16 }}>Bio</h5>
      {bio}
      {socialMediaTag && (
        <a
          href={socialMediaHref}
          sx={{
            color: '#50F094',
            fontWeight: 500,
            fontSize: 18,
            textDecoration: 'underline'
          }}
        >
          {socialMediaTag}
        </a>
      )}
    </div>
  </div>
)

const JudgesPanel = () => {
  const [modalIsOpen, setIsOpen] = useState(false)
  const [modalContent, setModalContent] = useState({})

  Modal.setAppElement('#app')
  const openModal = (
    name,
    title,
    bio,
    imgUrl,
    socialMediaTag,
    socialMediaHref
  ) => {
    setModalContent({
      name,
      title,
      bio,
      imgUrl,
      socialMediaTag,
      socialMediaHref
    })
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }
  return (
    <section>
      <Container>
        <h2
          sx={{
            textAlign: 'center',
            pt: [48, 64],
            pb: [32, 48],
            m: 0,
            color: '#F5F5F5',
            fontSize: ['36px', '42px']
          }}
        >
          Our judges
        </h2>
        <div
          sx={{
            display: 'grid',
            gridTemplateColumns: [
              'repeat(2, minmax(0, 1fr))',
              'repeat(3, minmax(0, 1fr))',
              'repeat(4, minmax(0, 1fr))'
            ],
            rowGap: 24,
            justifyItems: ['center', 'center', 'start'],
            alignItems: ['center', 'center', 'start'],
            pb: 64,
            wordWrap: 'wrap-word'
          }}
        >
          {JUDGES_CONFIG.map(
            ({ name, title, imgUrl, bio, socialMediaTag, socialMediaHref }) => (
              <div
                sx={{
                  display: 'flex',
                  flexDirection: ['column', 'column', 'row'],
                  maxWidth: '100%',
                  justifyContent: ['center', 'center', 'start'],
                  alignItems: ['center', 'center', 'start']
                }}
                key={name}
              >
                <RoundedImage imgUrl={imgUrl} />

                <div
                  sx={{
                    ml: ['8px', 16],
                    textAlign: ['center', 'center', 'left'],
                    lineHeight: 1.3
                  }}
                >
                  <p
                    sx={{ color: '#F6F6F6', fontWeight: 500, m: 0, mb: '4px' }}
                  >
                    {name}
                  </p>
                  <p sx={{ color: '#ADADAD', m: 0, mb: '4px' }}>{title}</p>
                  <span
                    sx={{
                      position: 'relative',
                      color: '#50F094',
                      cursor: 'pointer',
                      '::before': {
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        height: '1px',
                        width: '100%',
                        backgroundColor: '#50F094',
                        content: "''"
                      }
                    }}
                    onClick={() =>
                      openModal(
                        name,
                        title,
                        bio,
                        imgUrl,
                        socialMediaTag,
                        socialMediaHref
                      )
                    }
                  >
                    View Profile
                  </span>
                </div>
                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  style={customModalStyles}
                >
                  <ModalPopUp onClick={closeModal} {...modalContent} />
                </Modal>
              </div>
            )
          )}
        </div>
      </Container>
    </section>
  )
}

export default JudgesPanel
